const IMG = '/images/nutritionists';
const SHARED = '/images/shared';

const page = {
  slug: 'nutritionists',
  title: 'For Dietitians And Nutritionists',
  hero: {
    title: 'For Dietitians And Nutritionists',
    image: `${SHARED}/hero-partners.webp`,
  },
  blocks: [
    {
      type: 'split',
      image: `${IMG}/nutritionist.webp`,
      imageAlt: 'A woman wearing a white medical coat that says "nutritionist" on the front pocket',
      imageSide: 'right',
      groups: [
        {
          heading: "We'll Care For Your Clients",
          paragraphs: [
            "Let us be the practical white glove meal service for clients who don't like to cook. We'll make delicious, fresh, clean meals and deliver them right to your clients' doorsteps.",
          ],
        },
        {
          heading: 'With Your Help',
          paragraphs: [
            'We take all the nutritional and allergen information you provide, to craft individual meals ensuring your client gets what they need with every meal.',
            'Never worry again if your clients are following your advice. We provide a la carte and subscription options.',
            'We serve Manhattan, Brooklyn and Long Island City as well as Westchester and Jersey City/Hoboken.',
          ],
        },
      ],
      cta: { label: 'Contact Us', to: '/contact-form-general' },
    },
    {
      type: 'steps',
      heading: 'How We Work',
      // Matches the legacy section's "light-bold" theme — see trainers.js.
      tone: 'warm',
      items: [
        {
          text: "You share your client's dietary requirements. We can accommodate any requirement, across calories, macros, sodium, fats, fiber, and more.",
          image: `${SHARED}/step-ingredients.webp`,
          imageAlt: 'A display of cherry tomatoes, mushrooms, garlic and various colorful peppers',
        },
        {
          text: 'Your client selects their meals à la carte or signs up for our subscription plan. They specify how many lunches and dinners they want.',
          image: `${SHARED}/step-ordering.webp`,
          imageAlt: 'Man placing a food order on his phone with an open laptop in the background',
        },
        {
          text: "Our nutrition team analyzes the ingredients in our chefs recipes using information from the USDA's FoodData Central. We then group ingredients into categories: meat (animal or plant-based), veggies, starch, and sauce. Our chefs then get the weight instructions for each category of ingredients for every dish.",
          image: `${SHARED}/step-portioning.webp`,
          imageAlt: 'Various sized bowls and measuring spoons filled with different grains, legumes, and spices',
        },
        {
          text: "Meals are delivered fresh to your client's home or office each week.",
          image: `${SHARED}/step-delivery.webp`,
          imageAlt: 'Three rectangular glass containers with a healthy meal inside',
        },
      ],
    },
    {
      type: 'quote',
      image: `${SHARED}/emma-harvie.webp`,
      imageAlt: 'Image of Emma Harvie',
      name: 'Emma Harvie, Functional Nutritionist at',
      link: { label: 'Athleats Nutrition', href: 'https://athleatsnutrition.com/' },
      text: "As a nutritionist, it can be difficult if not seemingly impossible to find meal options for my clients that are convenient, flavorful, diverse, affordable AND that meet the client's nutritional needs. Square Fare checks all the boxes and more, and Claire makes the process of improving health and dietary habits a seamless process for both the client and the practitioner! Recommending Square Fare to health-conscious individuals, athletes, busy working professionals and anyone with a passion for good food is a total no-brainer. Thank you, Claire!",
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
